export default "__VITE_ASSET__6aPue3sj__"